<template>
  <modal
    :title="setModel != undefined ? 'Update Currency' : 'Add Currency'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        @submit="onSubmit"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
        v-if="currencies!=null"
      >
        <formGroup
          :title="'Currency Code'"
                as="select"
          v-model.number="model.CurrencyCode"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        >
                <template #input>
                    <option :value="item.Code" :key="item.Code" v-for="item in currencies">{{item.Code}}</option>
                  </template>
        
        </formGroup>
        <formGroup
          :title="'Hotel Currency Code'"
          v-model="model.HotelCurrencyCode"
          :rules="{ required: true }"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
      </Form>
      <load-area v-if="currencies==null"></load-area>
    </template>
    <template v-if="currencies!=null" #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update Code" : "Add Code"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    addId: Number,
  },
  data() {
    return {
      model: {
        Id:null,
          "HotelId":this.addId,
          "HotelCurrencyCode":null,
          "CurrencyCode":null
      },
      errs: {},
      process: false,
      currencies:null
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
    this.$appAxiosAdmin.get("Currencies").then((response) => {
      this.currencies = response.data;
    });
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`HotelCurrencies`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The currency has been successfully updated."
                    : "The currency has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
